export default "__VITE_PUBLIC_ASSET__7f7e4fe9__"